import { fork, all } from 'redux-saga/effects';

import { simpleRequestsLoader } from 'modules/app/utils';
import { EXPORT_BILLING_REQUEST, FETCH_BILLING_ENTITY_METRICS_REQUEST } from 'modules/metrics/actionTypes';
import dashboardSaga from 'modules/metrics/sagas/dashboard.saga';

const simpleRequests = {
  [FETCH_BILLING_ENTITY_METRICS_REQUEST]: {},
  [EXPORT_BILLING_REQUEST]: {
    notifications: {
      success: {
        id: 'statistics_intervention.export_success',
        defaultMessage: 'Export in progress. Please check your inbox in a few minutes.',
      },
      failure: {
        id: 'statistics_intervention.export_error',
        defaultMessage: 'An error occurred during the export of the statistics.',
      },
    },
  },
};

export default function* metricsCoreSaga() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield fork(dashboardSaga);
}
